import { jsx as s } from "react/jsx-runtime";
const e = "ids-autocomplete--popover-content-v501", n = "ids-autocomplete--option-list-v501", p = {
  popoverContent: e,
  optionList: n
}, r = ({
  noResultsText: o,
  styles: t = p
}) => typeof o == "string" ? /* @__PURE__ */ s("div", { className: t.noResults, children: o }) : o;
export {
  r as A,
  p as s
};
